import React, { ReactNode } from "react";
import { Flex } from "@chakra-ui/react";

import "./Layout.scss";

type TPageContainerProps = {
  children: ReactNode,
  isFixedNav?: boolean,
}

export default function PageContainer({ children, isFixedNav }: TPageContainerProps) {
  return (
    <Flex
      bg="secondary.background"
      minHeight="100%"
      width="100%"
      alignItems="center"
      justifyContent="top"
      flexDirection="column"
      paddingTop={isFixedNav ? { md: "4rem" } : "0"}
    >
      {children}
    </Flex>
  );
}